<template>
    <div>
        <HeaderItem />
        <div class="subject">
            <div class="list-group">
                <routeTabComponent />
                <div class="panel">
                    <div class="InternetThings">
                        <div class="borderLineDescripe aeroiotflex_between">
                            <div class="aeroiotflex_row">
                                <div class="tipBoxItem aeroiotflex_center" v-for="(item,index) in tipsList" :key="index">{{item.name}}：{{item.value}}</div>
                            </div>
                            <div class="aeroiotflex_row">
                                <el-input
                                    class="projectInput"
                                    v-model="input"
                                    size="mini"
                                    style="margin-right:10px;width:213px;"
                                    placeholder="请输入项目名称"
                                ><i slot="prefix" class="el-input__icon el-icon-search"></i></el-input>
                            </div>
                        </div>

                        <!-- <div v-if="monitorList.length==0" class="noMoniterBox aeroiotflex_center">
                            <div class="noMoniterBoxImg aeroiotflex_center">
                              <img src="@/assets/monitorListNoData.png" alt="">
                            </div>
                            <div>项目列表为空，快去创建项目吧～</div>
                        </div> -->
                        <div class="projectListDiaplay">
                            <div class="projectListItem">
                                <div class="aeroiotflex_row">
                                    <div class="projectimgBox aeroiotflex_center">
                                        <el-image class="projectimg">
                                            <div slot="error" class="image-slot">
                                               暂无图片
                                            </div>
                                        </el-image>
                                    </div>
                                    <div></div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <SignIn></SignIn>
        </div>
        <telephoneModule />
    </div>
</template>

<script>
import HeaderItem from "@/components/HeaderItem";
import SignIn from "@/components/SignIn";
import telephoneModule from "@/components/telephoneModule";
import routeTabComponent from "@/components/routeTabComponent";

export default {
    components: {
        HeaderItem,
        SignIn,
        routeTabComponent,
        telephoneModule,
    },
    data() {
        return {
            options: [
                {
                    value: "选项1",
                    label: "黄金糕",
                },
                {
                    value: "选项2",
                    label: "双皮奶",
                },
                {
                    value: "选项3",
                    label: "蚵仔煎",
                },
                {
                    value: "选项4",
                    label: "龙须面",
                },
                {
                    value: "选项5",
                    label: "北京烤鸭",
                },
            ],
            value: "",
            input: "",
            monitorList: [],
            tipsList:[
                {
                    name:'项目总数',
                    value:'4'
                },
                {
                    name:'边坡监测',
                    value:'1'
                },
                {
                    name:'隧道监测',
                    value:'1'
                },
                {
                    name:'水库监测',
                    value:'1'
                },
                {
                    name:'河堤监测',
                    value:'1'
                },
            ] 
        };
    },
};
</script>

<style scoped>
a {
    text-decoration: none;
}

.subject {
    /* 20220523 隐藏左侧栏 */
    /* position: absolute; */
    /* width: calc(100% - 50px); */
    width: 100%;
    min-height: 100vh;
    background-color: #eaedf5;
    left: 50px;
    display: flex;
    flex-direction: row;
}

.subject .list-group {
    width: 1408px;
    position: relative;
    margin: 63px 20px 20px 15px;
    min-height: 782px;
}

.subject .list-group .panel {
    border-top: 1px solid;
    border-color: #e2e4e7;
    width: 100%;
    background-color: white;
}
.InternetThings {
    min-height: 740px;
    padding: 0px 20px;
}
  .borderLineDescripe{
    height: 60px;
    border-bottom: 1px dashed #E2E4E7;
  }
  .noMoniterBoxImg{
    width: 190px;
    height: 190px;
    background: #F4F4F4;
    border-radius: 50%;
    margin-top: 172px;
    margin-bottom: 30px;
  }
  .noMoniterBox{
    flex-direction:column;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
  }
  .tipBoxItem{
    height: 23px;
    border: 1px solid #DFE1E6;
    font-size: 12px;
    font-weight: 400;
    padding: 0 10px 0 5px;
    color: #999999;
    margin-right: 10px;
  }
  .projectInput /deep/ .el-input__inner{
      background-color: rgba(244, 244, 244);
      border-radius: 0;
      border: none;
  }
  .projectimgBox{
    width: 70px;
    height: 70px;
    background: rgba(241,243,247);
    border-radius: 50%;
  }
  .projectimg /deep/ .image-slot{
        color: rgb(192, 196, 204);
        font-size: 14px;
  }
</style>


// WEBPACK FOOTER //
// src/view/monitorMannage/index.vue